import { Tags } from '../../interfaces';

export const wrapTags = (tags: Tags): string => {
  const tag = Object.entries(tags)
    .filter(([, value]) => value)
    .map(([type, value]) => `${type}#${value}#`)
    .join(' | ');

  return tag;
};
